
import { defineComponent } from "vue";
import moment from "moment"
export default defineComponent({
  name: "asign",
  props: {
    widgetClasses: String,
    dataCustomer: Object,
  },
  data() {
    return {
    }
  },
  components: {
  },
  methods: {
   
  },
});
